export default __webpack_public_path__ + "static/media/back.cb1c3d7c.svg";